// extracted by mini-css-extract-plugin
module.exports = {"comments":"PhotoComments_comments__NDbJ7","single":"PhotoComments_single__LCy-3"};